"use client"

import TablaRrhhEmpleadosComponent from "./TablaRrhhEmpleadosComponent.js"

const RrhhEmpleadosComponent = () => {
  return <TablaRrhhEmpleadosComponent />
}

export default RrhhEmpleadosComponent
